/**
 * CloudFront signed cookies for TME Wiki media.
 *
 * Planning/TME-WIKI-2026-09-02.md §5.4, §5.5, D19.
 *
 * Media URLs are stored as relative paths ("/tme-wiki-media/<wikiId>/…") and
 * served by the same CloudFront distribution as the portal, with signing
 * enforced - so the browser needs the three CloudFront-* cookies before any
 * <img> is fetched or any attachment is clicked.
 *
 * ⚠️ ONE SET COVERS EVERY INTERNAL WIKI (D19), so this takes NO ARGUMENTS. Per
 * wiki scoping restricted nobody - every admin may open every wiki - and broke
 * cross-wiki page links, whose images live under another wiki's prefix.
 *
 * ⚠️ THE FETCH GOES TO A RELATIVE PATH, NOT REACT_APP_API_URL. CloudFront routes
 * /admin/tme-wiki/media-cookies to the API
 * (scripts/tme-wiki-media-03-cookie-behaviour.sh), so it is same-origin with the
 * portal and same-host with the media. That matters twice over: the browser
 * stores the Set-Cookie without CORS being involved at all, and there is no
 * preflight to fail. Going via the API's own hostname does NOT work -
 * api-preview.themigrationexperts.com is a different ORIGIN even though it
 * shares the cookie domain, so the request is credentialed cross-origin and API
 * Gateway's CORS mock answers the preflight with '*' and no Allow-Credentials,
 * which the browser rejects.
 *
 * Local development (localhost:3001) has no such CloudFront path, so internal
 * wiki media does not render locally once signing is on. Testing is on preview.
 */

// Epoch seconds the current cookie expires. Re-fetching is cheap but pointless
// on every render, so a live cookie is reused until it is close to expiry.
let expiresAt = 0;
const REFRESH_MARGIN_SECONDS = 300;

function isStillValid() {
    return expiresAt - REFRESH_MARGIN_SECONDS > Math.floor(Date.now() / 1000);
}

/** Test seam - a fresh module per case, so one suite's cookie cannot satisfy another's. */
export function resetTmeWikiMediaCookies() {
    expiresAt = 0;
}

export async function ensureTmeWikiMediaCookies() {
    if (isStillValid()) return true;

    const token = localStorage.getItem('adminToken');
    if (!token) return false;

    try {
        const response = await fetch('/admin/tme-wiki/media-cookies', {
            method: 'GET',
            credentials: 'same-origin',
            headers: { Authorization: `Bearer ${token}` }
        });
        if (!response.ok) {
            console.error('TME wiki media cookies refused:', response.status);
            return false;
        }
        const data = await response.json();
        expiresAt = data.expiresAt || 0;
        return true;
    } catch (err) {
        console.error('TME wiki media cookie fetch failed:', err);
        return false;
    }
}
